import { render, staticRenderFns } from "./ModalSuporteCentroCirurgico.vue?vue&type=template&id=7f84c7cc&scoped=true"
import script from "./ModalSuporteCentroCirurgico.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteCentroCirurgico.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteCentroCirurgico.vue?vue&type=style&index=0&id=7f84c7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f84c7cc",
  null
  
)

export default component.exports